import { axios as request } from '@/utils/request.js'
import cookie from './cookie'
import tools from './tools'
import config from 'config'

export { 
    request, 
    cookie,
    tools,
    config
}